import { createContext, use } from 'react';

import type { OverviewReferences, OverviewSectionKey } from './OverviewAccordion.model';

export interface OverviewAccordionContextValue extends OverviewReferences {
  /** Expands the first section of this type and scrolls it into view. */
  revealSection: (type: OverviewSectionKey) => void;
}

export const OverviewAccordionContext = createContext<OverviewAccordionContextValue>({
  groupsByApiId: new Map(),
  treatmentsByApiId: new Map(),
  revealSection: () => undefined,
});

export const useOverviewAccordion = (): OverviewAccordionContextValue => use(OverviewAccordionContext);
